import { createNaveSessionClient } from "../infrastructure/auth/nave-session-client";

/** Production browser composition for the same-origin Nave BFF session API. */
export const productionSessionClient = createNaveSessionClient();
